// extracted by mini-css-extract-plugin
export default {"fab":"WhatsAppButton_fab__-YXjd","pulse":"WhatsAppButton_pulse__dIfCr","jc-pulse":"WhatsAppButton_jc-pulse__-5i6O"};